import PrimaryButtonPR from "./PrimaryButtonPR";

export default PrimaryButtonPR;
